// TODO: [jh 2025-06-20] camel it and serialization_alias in middleware

export type PromptCreateArgs = {
  prompt: Prompt<PromptReqIdentifier>;
};

export type PromptCreateRes = object;

export type PromptDeleteArgs = PromptReqIdentifier;

export type PromptDeleteRes = object;

export type PromptGetArgs = PromptReqIdentifier;

export type PromptGetRes = Prompt<PromptResIdentifier>;

export type PromptsGetArgs = Pick<PromptReqIdentifier, 'name' | 'tags'> & {
  only_latest?: boolean;
  page?: number;
  pageSize?: number;
};

export type PromptsGetRes = {
  prompts: Prompt<PromptResIdentifier>[];
  page: number;
  number_of_pages: number;
};



export enum PromptTypeEnum {
  SIMPLE = 'simple',
  MESSAGE = 'message'
};





export type Prompt<T = PromptResIdentifier> = {
  author: string;
  created_date?: string;
  description: string;
  id: T;
  messages?: PromptMsg[] | null;
  prompt_text?: string | null;
  system_prompt?: string | null;
};

export type PromptResIdentifier = {
  name: string;
  tags: string[] | null;
  version: number | null;
};

export type PromptReqIdentifier = {
  name: string;
  tags: string | null;
  version: number | null
};

export type PromptMsg = {
  content: string;
  name: string;
  role: PromptMsgAuthorType;
};

export type PromptMsgAuthorType = typeof PromptMsgAuthorEnum[keyof typeof PromptMsgAuthorEnum];
export const PromptMsgAuthorEnum = {
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
  USER: 'user'
} as const;